import { useQuery } from '@tanstack/react-query';
import { optInFeaturesQueryKeys } from '../Constants/queryKeys';
import { getOptInAdoption } from '../Services/OptInFeatures.service';

export const useOptInAdoption = (id?: string) =>
  useQuery({
    queryKey: optInFeaturesQueryKeys.adoption(id ?? ''),
    queryFn: () => getOptInAdoption(id ?? ''),
    enabled: Boolean(id),
  });
